import { z } from 'zod'

export const loginSchema = z.object({
  email: z.string().min(1, 'Ingresa tu correo.').email('Correo inválido.'),
  password: z.string().min(1, 'Ingresa tu contraseña.'),
})

export type LoginFormValues = z.infer<typeof loginSchema>

export const forgotPasswordSchema = z.object({
  email: z.string().min(1, 'Ingresa tu correo.').email('Correo inválido.'),
})

export type ForgotPasswordFormValues = z.infer<typeof forgotPasswordSchema>

// PC-FINAL-3: mismas reglas que _PASSWORD_RULES en app/schemas/auth.py
// (validate_strong_password) -- feedback inmediato en el cliente, la
// validación real sigue ocurriendo en el backend.
const strongPassword = z
  .string()
  .min(10, 'Debe tener al menos 10 caracteres.')
  .max(128, 'Máximo 128 caracteres.')
  .regex(/[a-z]/, 'Debe incluir una minúscula.')
  .regex(/[A-Z]/, 'Debe incluir una mayúscula.')
  .regex(/\d/, 'Debe incluir un dígito.')

export const resetPasswordSchema = z
  .object({
    token: z.string().min(20, 'Código inválido.').max(200, 'Código inválido.'),
    newPassword: strongPassword,
    confirmPassword: z.string().min(1, 'Confirma tu nueva contraseña.'),
  })
  .refine((values) => values.newPassword === values.confirmPassword, {
    message: 'Las contraseñas no coinciden.',
    path: ['confirmPassword'],
  })

export type ResetPasswordFormValues = z.infer<typeof resetPasswordSchema>
